var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNega({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M11 9h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H6a1 1 0 0 1 0-2h3V6a1 1 0 1 1 2 0v3zm4.405-7.415a.833.833 0 0 1-.902 1.402 8.333 8.333 0 1 0 2.5 2.493.833.833 0 1 1 1.399-.905A9.956 9.956 0 0 1 20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0c1.943 0 3.806.556 5.405 1.585z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNega);
export default __webpack_public_path__ + "static/media/add-nega.710b57adb18221910f1fbbe68b4b9237.svg";
export { ForwardRef as ReactComponent };